import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UsersRole } from 'src/model/enum/enumDigitalPlace';

export function taxCodeOrVatRequiredIfRole(targetRole: UsersRole): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const role = group.get('role')?.value;
    const taxCode = group.get('taxCode')?.value;
    const vatNumber = group.get('VATNumber')?.value;

    if (role === targetRole) {
      if (!taxCode && !vatNumber) {
        return { taxCodeOrVatRequired: true };
      }
    }

    return null;
  };
}
